import { useLogoutQry } from 'mmfintech-backend-api'
import { tr, useDropDownMenu } from 'mmfintech-commons'
import type React from 'react'
import { Link } from 'react-router-dom'
import './UserDropDownMenu.scss'

interface Props {
  UserMenuItems: React.ComponentType<{ onClick: () => void; className?: string }>
}

function UserDropDownMenu({ UserMenuItems }: Props) {
  const { visible, hideDropDown, toggleDropDown } = useDropDownMenu()

  const { logout } = useLogoutQry()

  function handleLogout(e: React.BaseSyntheticEvent) {
    e.preventDefault()
    hideDropDown()
    void logout()
    return false
  }

  return (
    <div className='dropdown-menu'>
      <div className='dropdown-menu__icon' onClick={toggleDropDown}>
        <span className='menu-icon' />
      </div>

      {visible && (
        <div className='dropdown-menu__container'>
          <UserMenuItems onClick={hideDropDown} className='menu-item selector' />
          <div className='menu-footer'>
            <Link to='#' className='menu-item logout' onClick={handleLogout}>
              {tr('PORTAL.HEADER.LOGOUT', 'Log out')}
            </Link>
          </div>
        </div>
      )}
    </div>
  )
}

export default UserDropDownMenu
